'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forTesting = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pick = require('lodash/fp/pick');

var _pick2 = _interopRequireDefault(_pick);

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _compose = require('lodash/fp/compose');

var _compose2 = _interopRequireDefault(_compose);

var _reactHotkeys = require('react-hotkeys');

var _setWrappedDisplayName = require('./setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeBuildHandlers = function makeBuildHandlers(keyMap) {
  return (0, _compose2.default)((0, _mapValues2.default)(function (handler) {
    return function (event) {
      event.stopPropagation();
      handler();
      return false;
    };
  }), (0, _compose2.default)(_pick2.default, Object.keys)(keyMap));
};

var element = _react2.default.createElement;
var func = _propTypes2.default.func;

var enhancer = function enhancer(keyMap) {
  return function (BaseComponent) {
    var buildHandlers = makeBuildHandlers(keyMap);

    var BindHotKeys = function BindHotKeys(props) {
      return element(_reactHotkeys.HotKeys, { keyMap: keyMap, handlers: buildHandlers(props) }, element(BaseComponent, props));
    };

    BindHotKeys.propTypes = (0, _mapValues2.default)(function () {
      return func.isRequired;
    })(keyMap);

    return BindHotKeys;
  };
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'bindHotKeys', true);


var forTesting = { makeBuildHandlers: makeBuildHandlers };
exports.forTesting = forTesting;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/bindHotKeys.js
// module id = 1329
// module chunks = 0